// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-text-item-table-panel-handler {
  position: absolute;
  color: var(--fi-color-dark);
  background-color: var(--fi-background-color-light);
  border-radius: 5px;
  z-index: 1;
  display: flex;
  padding: 5px 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 18px 5px, rgba(0, 0, 0, 0.05) 0px 4px 6px 0px;
}
.fi-text-item-table-panel-handler .table-panel-option-container {
  display: inline-block;
  vertical-align: middle;
}
.fi-text-item-table-panel-handler .table-panel-option-container .mat-mdc-button {
  padding: 5px 10px;
  width: 100%;
  min-width: 100%;
  height: 100%;
}
.fi-text-item-table-panel-handler .table-panel-option-container .fi-info-icon {
  width: 1px !important;
  height: 1px !important;
  left: 50% !important;
}`, "",{"version":3,"sources":["webpack://./Source/app/utilities/fi-text-item-table-panel-handler/fi-text-item-table-panel-handler.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,2BAAA;EACA,kDAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,oFACI;AAAR;AAGI;EACI,qBAAA;EACA,sBAAA;AADR;AAEQ;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAAZ;AAEQ;EACI,qBAAA;EACA,sBAAA;EACA,oBAAA;AAAZ","sourcesContent":[".fi-text-item-table-panel-handler {\r\n    position: absolute;\r\n    color: var(--fi-color-dark);\r\n    background-color: var(--fi-background-color-light);\r\n    border-radius: 5px;\r\n    z-index: 1;\r\n    display: flex;\r\n    padding: 5px 10px;\r\n    box-shadow:\r\n        rgb(0 0 0 / 10%) 0px 5px 18px 5px,\r\n        rgb(0 0 0 / 5%) 0px 4px 6px 0px;\r\n\r\n    .table-panel-option-container {\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        .mat-mdc-button {\r\n            padding: 5px 10px;\r\n            width: 100%;\r\n            min-width: 100%;\r\n            height: 100%;\r\n        }\r\n        .fi-info-icon {\r\n            width: 1px !important;\r\n            height: 1px !important;\r\n            left: 50% !important;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
